import { apiClient } from './apiClient';

const READER_SETTINGS_API = '/api/app/reader-settings-extn';

export interface ReaderSettingDto {
  id: string;
  userId: string;
  theme: string;
  fontSize: number;
  fontFamily: string;
  lineHeight: number;
  backgroundColor: string;
  textColor: string;
  autoHideToolbar: boolean;
  autoHideDelayMs: number;
  /** Backend integer mapping to LayoutMode enum (0=Auto, 1=Single, 2=Spread, 3=Scrolling). */
  layoutMode: number;
  /** Backend integer mapping to PageAnimation enum (0=Slide, 1=Fade, 2=None). */
  pageAnimation: number;
  /** Backend integer mapping to PageMargin enum (0=Medium, 1=Narrow, 2=Wide). */
  pageMargin: number;
  /** Backend integer mapping to TapZoneMode enum (0=Auto, 1=On, 2=Off). */
  tapZoneMode: number;
  concurrencyStamp?: string;
}

export interface ReaderSettingUpdateDto {
  userId: string;
  theme: string;
  fontSize: number;
  fontFamily: string;
  lineHeight: number;
  backgroundColor: string;
  textColor: string;
  autoHideToolbar: boolean;
  autoHideDelayMs: number;
  /** Backend integer mapping to LayoutMode enum (0=Auto, 1=Single, 2=Spread, 3=Scrolling). */
  layoutMode: number;
  /** Backend integer mapping to PageAnimation enum (0=Slide, 1=Fade, 2=None). */
  pageAnimation: number;
  /** Backend integer mapping to PageMargin enum (0=Medium, 1=Narrow, 2=Wide). */
  pageMargin: number;
  /** Backend integer mapping to TapZoneMode enum (0=Auto, 1=On, 2=Off). */
  tapZoneMode: number;
  concurrencyStamp: string;
}

export const readerSettingsService = {
  /**
   * Get reader settings for current user
   * Auto-creates defaults if doesn't exist
   */
  async getMySettings(): Promise<ReaderSettingDto> {
    const response = await apiClient.get<ReaderSettingDto>(
      `${READER_SETTINGS_API}/my-settings`
    );
    return response.data;
  },

  /**
   * Update reader settings for current user
   */
  async updateMySettings(input: Omit<ReaderSettingUpdateDto, 'userId' | 'concurrencyStamp'>): Promise<ReaderSettingDto> {
    // Fetch current settings to get concurrencyStamp and userId
    const currentSettings = await this.getMySettings();

    // Merge with update data
    const updateDto: ReaderSettingUpdateDto = {
      ...input,
      userId: currentSettings.userId,
      concurrencyStamp: currentSettings.concurrencyStamp || '',
    };

    const response = await apiClient.put<ReaderSettingDto>(
      `${READER_SETTINGS_API}/my-settings`,
      updateDto
    );
    return response.data;
  },
};
